import { TypographyV3 } from '@jouzen/ecom-components';
import { cx } from 'class-variance-authority';
import { useTranslations } from 'next-intl';
import type { MessageKey } from 'types/LocaleMessageKey';

import type { CompareModelsTableHeaderVAlign } from './types';

export interface CompareModelsTableHeaderProps {
  readonly isLastRow: boolean;
  readonly label: MessageKey;
  readonly verticalAlign: CompareModelsTableHeaderVAlign;
}

const CompareModelsTableHeader = ({
  isLastRow,
  label,
  verticalAlign,
}: CompareModelsTableHeaderProps) => {
  const t = useTranslations();

  return (
    <div
      className={cx('w-full lg:flex lg:w-1/4 lg:max-w-60', {
        'lg:items-start': verticalAlign === 'top',
        'lg:items-center': verticalAlign === 'center',
        'lg:border-b lg:border-gray-300 lg:pb-6': !isLastRow,
      })}
      data-cy="compare-models-table-header"
      role="rowheader"
    >
      <TypographyV3
        className="tracking-tight lg:text-xl"
        Element="span"
        weight="bold"
      >
        {t(label)}
      </TypographyV3>
    </div>
  );
};

export default CompareModelsTableHeader;
